import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Link, useLocation } from 'react-router-dom'
import { withAuth } from './AuthContext'

import {
  textTranslation,
  shouldTranslateTo,
  getCurrentLanguageName,
} from '../utils/utils'

import { Title, Subtitle, Button, FlexRow } from './Utils/CustomClassesV2'

import Cookies from 'universal-cookie'

// Define styled components

const beige = '#FFFBF4'
const darkBeige = '#EEE8DE'
const darkBlue = '#154549'
const white = '#ffffff'
const red = '#EB5E55'

const cookies = new Cookies()
const queryParams = new URLSearchParams(window.location.search)

var languageFlag = ''
if (queryParams.get('lc') !== undefined && queryParams.get('lc') !== null) {
  languageFlag = queryParams.get('lc')
} else if (cookies.get('lC') !== undefined && cookies.get('lC') !== null) {
  languageFlag = cookies.get('lC')
} else {
  languageFlag = 'en'
}

const links = {
  home: '/',
  membershipWorks: '/how-it-works',
  faqs: '/faq',
  locals: '/search?seeking=locals',
  homestays: '/search?seeking=homestays',
  becomeAHost: '/become-host',
  addEditHomestay: '/dashboard/edit-place',
  aboutUs: '/about-us',
  blog: '/article',
  communityPortal: '/dashboard/community2',
  joinClub: '/signup-form',
  login: '/login',
  dashboard: '/dashboard',
  messages: '/dashboard/messages',
  logout: '/logout',
  prices: '/prices',
}

const MainHeader = styled.header`
  z-index: 1000;

  position: absolute;
  top: 0px;
  left: 0;
  background-color: transparent;
  height: 100px;
  width: 100%;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 500ms;

  &.hide {
    top: -100px;
  }

  @media screen and (max-width: 550px) {
    transition-property: none !important;
    transition: none !important;
    &.hide {
      top: 0px;
    }
  }
`

const HeaderContainerDesktop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* padding: 20px 3vw; */
  height: 70px;
  padding-left: 3vw;
`

const HeaderContainerTablet = styled(HeaderContainerDesktop)`
  padding: 0 0 0 3vw;

  & > div {
    display: flex;
  }
`

const Logo = styled.div`
  img {
    width: 100%;
    max-width: 110px;

    @media screen and (max-width: 400px) {
      padding-right: 10px;
    }
  }
  /* @media screen and (max-width: 1124px) {
    img {
        max-width: 90%;
    }
  }

  @media screen and (max-width: 600px) {
    img {
        max-width: 80%;
    }
  } */
`

const Nav = styled.nav`
  display: flex;
  align-items: center;
  padding: 0 5vw;

  width: -webkit-fill-available;
  max-width: 1000px;
  justify-content: space-between;
`

const DynamicNav = styled(Nav)`
  @media screen and (max-width: 360px) {
    display: none;
  }
`

const NavTablet = styled.nav`
  /* padding: 0 3vw; */
  display: flex;
  align-items: center;

  gap: 3px;
`

const NavLink = styled.a`
  text-decoration: none;
  color: #fff;
  cursor: pointer;

  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  font-weight: 200 !important;
  line-height: 146%;

  white-space: nowrap;

  &:hover {
    text-decoration: underline;
    color: #fff;
  }

  @media screen and (max-width: 1124px) {
    font-size: 1rem;
  }
`

const NavLinkDropDown = styled(NavLink)`
  background-color: #154549;
`

const Top = styled.div`
  background-color: #154549;
  height: 30px;
  display: flex;
  align-items: center;
  padding: 0 3vw 8px;
  justify-content: flex-end;
  gap: 3vw;
`

const TopLeft = styled.div`
  height: 30px;
  display: flex;
  align-items: center;
  padding: 0;
  justify-content: flex-start;
  gap: 3vw;
  max-width: 100px;
`

const TopRight = styled.div`
  height: 30px;
  display: flex;
  align-items: center;
  padding: 0;
  justify-content: flex-end;
  gap: 3vw;
  width: -webkit-fill-available;
`

const TopBarHome = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  h2,
  a {
    text-decoration: none;
  }
`

const HomeImage = styled.img`
  width: 17px;
`

const HomeSubtitle = styled(Subtitle)`
  margin-top: 2px;
`

const LanguageChange = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  h2,
  a {
    text-decoration: none;
  }
`

const CustomButton = styled(Button)`
  white-space: nowrap;

  @media screen and (max-width: 950px) {
    margin-right: 15px;

    a {
      padding: 9px 35px;
    }
  }
`

const FlagImage = styled.img`
  width: 20px;
  border-radius: 5px;
`

const CustomLink = styled.div`
  &:link {
    text-decoration: none;
  }
  &:visited {
    text-decoration: none;
  }
  &:hover {
    text-decoration: none;
  }
  &:active {
    text-decoration: none;
  }
`

const LoginButton = styled(Button)`
  border-radius: 0;
  a {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    @media screen and (max-width: 950px) {
      padding: 9px 50px;
    }

    @media screen and (max-width: 600px) {
      padding: 6px 50px;
    }
  }
`

const DropdownClickOptionTwo = styled.div`
  display: inline-block;
  position: relative;
  width: 100%;

  button {
    border: none;
    padding: 0;
    cursor: pointer;
    background: transparent;

    color: #fff;
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    font-weight: 200 !important;
    line-height: 146%;

    white-space: nowrap;
  }

  .tablet-nav {
    padding: 13px 3vw;
    background-color: transparent;
    /* margin-left: 25px; */
    img {
      width: 63px;
      padding: 10px;
    }

    & .dropdown-options {
      left: unset !important;
      transform: unset !important;
    }

    @media screen and (max-width: 600px) {
      padding: 13px 3.2vw;
      /* margin-left: 10px; */
    }
  }

  .show-icon {
    &::after {
      content: url('/images/arrow-down-2-white.svg');
      margin-left: 10px;
    }
  }

  .right {
    padding-top: 0px;
    float: right;
    right: 0;
  }

  .center {
    left: 50%;
    transform: translateX(-50%);
  }

  @-webkit-keyframes fadeIn {
    from {
      opacity: 0;
      -webkit-transform: translate3d(100%, 0, 0);
      transform: translate3d(100%, 0, 0);
    }

    to {
      opacity: 1;
      -webkit-transform: none;
      transform: none;
    }
  }
  @keyframes fadeIn {
    from {
      opacity: 0;
      -webkit-transform: translate3d(100%, 0, 0);
      transform: translate3d(100%, 0, 0);
    }

    to {
      opacity: 1;
      -webkit-transform: none;
      transform: none;
    }
  }

  .dropdown-options.inactive {
    display: none;
  }

  .dropdown-options.active {
    display: block;
    background-color: transparent;
    position: absolute;
    border-radius: 5px;
    top: 69px;

    @media screen and (max-width: 550px) {
      position: fixed;
      left: 0;
      top: 100px;
      text-align: center;
    }

    -webkit-animation-duration: 0.5s;
    animation-duration: 0.5s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;

    -webkit-animation-delay: 0s;
    -moz-animation-delay: 0s;
    animation-delay: 0s;

    -webkit-animation-name: fadeIn;
    animation-name: fadeIn;
    z-index: 2000;
  }

  .dropdown-options.active a {
    display: block;

    color: #fff;
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    font-weight: 200 !important;
    line-height: 146%;

    padding: 20px 40px;
    width: -webkit-fill-available;
    white-space: nowrap;

    border-top: 2px solid #f6f0e6;

    &:last-child {
      border-bottom: 2px solid #f6f0e6;
    }
  }

  & .dropdown-options a:hover {
    color: #0a0a23;
    background-color: #ddd;
  }
`

const DropdownClickOptionTwoHidden = styled(DropdownClickOptionTwo)`
  display: none;
`

const DropdownClickUser = styled(DropdownClickOptionTwo)`
  button {
    display: flex;
    white-space: nowrap;
    align-items: center;
    gap: 12px;
    height: 70px;
    width: 210px;

    p {
      margin-bottom: 0;
      font-family: 'Open Sans', sans-serif;
      font-weight: 200 !important;
      color: #fff;
      font-size: 16px;
      width: 100%;

      &::after {
        content: url('/images/arrow-down-2-white.svg');
        margin-left: 10px;
      }

      @media screen and (max-width: 430px) {
        font-size: 1rem;
      }
    }
  }

  .user-nav {
    padding: 8px 1.5vw;
    background-color: transparent;
    img {
      width: 50px;
      height: 50px;
      object-fit: cover;
      border-radius: 50%;
      vertical-align: middle;
    }

    & .dropdown-options {
      left: unset !important;
      transform: unset !important;
    }

    @media screen and (max-width: 600px) {
      padding: 13px 3.2vw;
      /* margin-left: 15px; */
    }
  }

  .tablet-nav {
    margin-left: unset;
  }

  .dropdown-options.active {
    width: -webkit-fill-available;
    text-align: center;
  }

  @-webkit-keyframes fadeInDown {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(0, -100%, 0);
      transform: translate3d(0, -100%, 0);
    }
    100% {
      opacity: 1;
      -webkit-transform: none;
      transform: none;
    }
  }
  @keyframes fadeInDown {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(0, -100%, 0);
      transform: translate3d(0, -100%, 0);
    }
    100% {
      opacity: 1;
      -webkit-transform: none;
      transform: none;
    }
  }

  @media screen and (max-width: 600px) {
    .dropdown-options.active {
      width: -webkit-fill-available;
      -webkit-animation-name: fadeInDown;
      animation-name: fadeInDown;
      z-index: 2000;
    }
  }
`

const CapsSubtitle = styled(Subtitle)`
  text-transform: uppercase;
  &::after {
    content: url('/images/arrow-down-2-white.svg');
    margin-left: 5px;
    margin-top: -2px;
  }
`

const LoginDiv = styled.div`
  padding-right: ${(props) => (!props.isloggedin ? '3vw' : '0')};
  width: 280px;
`

const handleLogin = () => {
  window.open('/auth0/login', '_self')
}

const Modal = ({ handleClose, showModal, languages }) => {
  const showHideClassName = showModal
    ? 'modal-aaa aaa-display-block'
    : 'modal-aaa aaa-display-none'

  const handleLanguageChange = (value) => {
    var currentUrlArr = window.location.href.split('?')
    var currentUrl = currentUrlArr[0]
    var newQueryString = ''
    if (currentUrlArr.length > 1) {
      var queryStringArr = currentUrlArr[1].split('&')
      queryStringArr.forEach(function (item) {
        if (!item.includes('lc=')) {
          newQueryString += '&' + item
        }
      })
    }
    window.location.href = currentUrl + '?lc=' + value + newQueryString
  }

  const Language = ({ id, label, value }) => (
    <li key={id}>
      <a
        className="lang"
        href="#"
        data-value={value}
        onClick={(e) => {
          e.preventDefault()
          handleLanguageChange(value)
        }}
      >
        <img
          alt={`${label}`}
          src={`/images/languages/${value}.svg`}
          className="flag"
        />
        {label}
      </a>
    </li>
  )

  return (
    <div className={showHideClassName}>
      <section className="modal-aaa-main">
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            Settings
          </h5>
          <button type="button" className="close" onClick={handleClose}>
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div>
          <h2>Choose your preferred language</h2>
          <div>
            <ul className="lang-list">{languages.map(Language)}</ul>
          </div>
        </div>
        <div className="modal-footer">
          <button
            className="btn btn-secondary"
            type="button"
            onClick={handleClose}
          >
            Close
          </button>
        </div>
      </section>
    </div>
  )
}

const LanguageChangeHandler = ({ showLabel }) => {
  return (
    <LanguageChange>
      {showLabel ? (
        <Subtitle
          color="#fff"
          size="16px"
          sizemd="1rem"
          sizesm="18px"
          dangerouslySetInnerHTML={{ __html: 'Language:' }}
        />
      ) : null}
      <FlagImage
        src={'/images/languages/' + languageFlag + '.svg'}
        alt={languageFlag}
        className="flag"
      />
      <CapsSubtitle
        color="#fff"
        size="16px"
        sizemd="1rem"
        sizesm="18px"
        dangerouslySetInnerHTML={{ __html: languageFlag }}
      />
    </LanguageChange>
  )
}

const TopBarHomeLink = () => {
  return (
    <TopBarHome>
      <Link to="/">
        <HomeImage
          src={'/images/home-small.svg'}
          alt={languageFlag}
          className="flag"
        />
      </Link>
      <Link to="/">
        <HomeSubtitle
          color="#fff"
          size="15px"
          sizemd="15px"
          sizesm="15px"
          dangerouslySetInnerHTML={{ __html: 'Home' }}
        />
      </Link>
    </TopBarHome>
  )
}

const HeaderOptionOne = ({
  setShowModal,
  isloggedin,
  userData,
  handleLogout,
  pageText,
}) => {
  const [showMenuUser, SetShowMenuUser] = useState(false)
  return (
    <>
      <Top>
        <TopLeft>{/*<TopBarHomeLink />*/}</TopLeft>
        <TopRight>
          <CustomLink onClick={() => setShowModal(true)}>
            <LanguageChangeHandler showLabel={true} />
          </CustomLink>
          {isloggedin === false ? (
            <Link onClick={() => handleLogin()}>
              <LoginButton background={darkBeige}>
                <a>
                  <img src="/images/user.svg" />
                  <Subtitle
                    color={white}
                    size="18px"
                    sizemd="1rem"
                    sizesm="18px"
                    dangerouslySetInnerHTML={{
                      __html: pageText[0],
                    }}
                  />
                </a>
              </LoginButton>
            </Link>
          ) : (
            ''
          )}
        </TopRight>
      </Top>
      <HeaderContainerDesktop>
        <Logo>
          <img
            src="/images/freebird_transparent_cropped_white.svg"
            alt="Freebird Club"
            className="logo"
          />
        </Logo>
        <Nav className="with-gap">
          {/*<NavLink href={links.home}>{pageText[18]}</NavLink>*/}
        </Nav>
        <LoginDiv isloggedin={isloggedin}>
          {isloggedin ? (
            <LoggedUser
              user={userData}
              handleLogout={handleLogout}
              pageText={pageText}
              SetShowMenuUser={SetShowMenuUser}
              showMenuUser={showMenuUser}
            />
          ) : (
            <Link to={links.joinClub}>
              <CustomButton background={red}>
                <a>{pageText[11]}</a>
              </CustomButton>
            </Link>
          )}
        </LoginDiv>
      </HeaderContainerDesktop>
    </>
  )
}

const HeaderOptionTwo = ({
  setShowModal,
  isloggedin,
  userData,
  handleLogout,
  pageText,
}) => {
  const [showMenu, SetShowMenu] = useState(false)
  const [showMenuUser, SetShowMenuUser] = useState(false)

  useEffect(() => {
    showMenuUser === true ? SetShowMenu(false) : ''
  }, [showMenuUser])

  useEffect(() => {
    showMenu === true ? SetShowMenuUser(false) : ''
  }, [showMenu])

  return (
    <>
      <Top>
        <TopLeft>{/*<TopBarHomeLink />*/}</TopLeft>
        <TopRight>
          {!isloggedin && (
            <Link onClick={() => handleLogin()}>
              <LoginButton background={darkBeige}>
                <a>
                  <img src="/images/user.svg" />
                  <Subtitle
                    color={white}
                    size="18px"
                    sizemd="1rem"
                    sizesm="18px"
                    dangerouslySetInnerHTML={{
                      __html: pageText[0],
                    }}
                  />
                </a>
              </LoginButton>
            </Link>
          )}
          <CustomLink onClick={() => setShowModal(true)}>
            <LanguageChangeHandler showLabel={false} />
          </CustomLink>
        </TopRight>
      </Top>
      <HeaderContainerTablet>
        <Logo>
          <img
            src="/images/freebird_transparent_cropped_white.svg"
            alt="Freebird Club"
            className="logo"
          />
        </Logo>
        {/*
        <DynamicNav className="with-gap">
          <NavLink href={links.home}>{pageText[18]}</NavLink>
        </DynamicNav>
        */}
        <NavTablet className="with-gap">
          {isloggedin ? (
            <LoggedUser
              user={userData}
              handleLogout={handleLogout}
              pageText={pageText}
              SetShowMenuUser={SetShowMenuUser}
              showMenuUser={showMenuUser}
            />
          ) : (
            <Link to={links.joinClub}>
              <CustomButton background={red}>
                <a>{pageText[11]}</a>
              </CustomButton>
            </Link>
          )}
          <DropdownClickOptionTwoHidden>
            <button
              className="tablet-nav"
              onClick={() => SetShowMenu(!showMenu)}
            >
              <img
                src={
                  showMenu ? '/images/hamburger-x.svg' : '/images/hamburger.svg'
                }
              />
            </button>
            <div
              className={`dropdown-options ${
                showMenu ? 'active' : 'inactive'
              } right`}
            >
              <NavLink href={links.membershipWorks}>{pageText[2]}</NavLink>
              <NavLink href={links.prices}>{pageText[22]}</NavLink>
              <NavLink href={links.faqs}>{pageText[3]}</NavLink>
              <NavLink href={links.locals}>{pageText[5]}</NavLink>
              <NavLink href={links.homestays}>{pageText[6]}</NavLink>
              <NavLink href={links.becomeAHost}>{pageText[7]}</NavLink>
              <NavLink href={links.aboutUs}>{pageText[8]}</NavLink>
              <NavLink href={links.blog}>{pageText[9]}</NavLink>
              {isloggedin &&
              userData.emailStatus === 'verified' &&
              userData.introductionStatus === 'completed' &&
              userData.profilePhotoStatus == 'completed' &&
              userData.membershipFeeStatus == 'completed' ? (
                <NavLinkDropDown href={links.communityPortal}>
                  {pageText[10]}
                </NavLinkDropDown>
              ) : null}
              <NavLink href={links.home}>{pageText[18]}</NavLink>
            </div>
          </DropdownClickOptionTwoHidden>
        </NavTablet>
      </HeaderContainerTablet>
    </>
  )
}

const LoggedUser = ({
  user,
  handleLogout,
  pageText,
  showMenuUser,
  SetShowMenuUser,
}) => {
  return (
    <DropdownClickUser>
      <button
        className="user-nav"
        onClick={() => SetShowMenuUser(!showMenuUser)}
      >
        <p>{pageText[12]}</p>
      </button>
      <div
        className={`dropdown-options ${showMenuUser ? 'active' : 'inactive'} `}
      >
        {user.emailStatus === 'verified' &&
          user.introductionStatus === 'completed' &&
          user.profilePhotoStatus == 'completed' &&
          user.membershipFeeStatus == 'completed' && (
            <>
              <NavLinkDropDown href={links.communityPortal}>
                {pageText[10]}
              </NavLinkDropDown>
              <NavLinkDropDown href={links.dashboard}>
                {pageText[13]}
              </NavLinkDropDown>
              <NavLinkDropDown href={links.addEditHomestay}>
                {pageText[16]}
              </NavLinkDropDown>
            </>
          )}

        {/*<NavLinkDropDown href={links.home}>{pageText[17]}</NavLinkDropDown>*/}
        <NavLinkDropDown
          onClick={() => {
            handleLogout()
          }}
        >
          {pageText[15]}
        </NavLinkDropDown>
      </div>
    </DropdownClickUser>
  )
}

//Header show scroll down and hide on scroll up
const useScrollDirection = () => {
  const [scrollDirection, setScrollDirection] = useState(null)

  useEffect(() => {
    let lastScrollY = window.pageYOffset

    const updateScrollDirection = () => {
      const scrollY = window.pageYOffset
      const direction = scrollY > lastScrollY ? 'down' : 'up'
      if (
        direction !== scrollDirection &&
        (scrollY - lastScrollY > 5 || scrollY - lastScrollY < -5)
      ) {
        setScrollDirection(direction)
      }
      lastScrollY = scrollY > 0 ? scrollY : 0
    }
    window.addEventListener('scroll', updateScrollDirection) // add event listener
    return () => {
      window.removeEventListener('scroll', updateScrollDirection) // clean up
    }
  }, [scrollDirection])

  return scrollDirection
}

const NewHeaderOnboarding = ({ auth }) => {
  const [showModal, setShowModal] = useState(false)
  const [languages, setLanguages] = useState([])
  const [currentLangName, setCurrentLangName] = useState(null)

  const [sizeModelShow, setSizeModelShow] = useState('')

  let { loggedIn, user } = auth

  const [isloggedin, setIsLoggedIn] = useState(loggedIn)
  const [userData, setUserData] = useState(user)

  const scrollDirection = useScrollDirection()

  const [pageText, setPageText] = useState([])

  //Language change text
  React.useEffect(() => {
    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageText(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    getPageText('header-new', language)
  }, [])

  //event listener for window resize and handle change languages
  useEffect(() => {
    window.addEventListener('resize', handleResize, false)
    handleResize()

    axios
      .get('/api/languages')
      .then((res) => {
        const languages = res.data.map(function (language) {
          return {
            id: language.id,
            label: language.name,
            value: language.code,
          }
        })
        if (currentLangName === null) {
          setCurrentLangName('French')
        }
        setLanguages(languages)
      })
      .catch((e) => {
        console.log(e)
      })
  }, [])

  //state manager for loggedIn and userData
  useEffect(() => {
    // console.log('AUTH: ', auth)
    // console.log('loggedIn: ', loggedIn);
    // console.log('user: ', user);

    let { loggedIn, user } = auth
    setIsLoggedIn(loggedIn)
    loggedIn && setUserData(user)
  }, [auth])

  const handleResize = () => {
    if (window.innerWidth > 950) {
      setSizeModelShow('Desktop')
    } else {
      setSizeModelShow('Tablet/Mobile')
    }
  }

  const handleLogout = () => {
    window.open('/auth0/logout', '_self')
    /*
        axios
            .post("/api/logout")
            .then((response) => {
                setIsLoggedIn(false);
                setUserData(null);
                // ud stands for user data
                localStorage.removeItem("ud");
                cookies.remove("laravelsession");
                this.props.history.push("/");
            })
            .catch((err) => {
                this.props.history.push("/");
            });
        */
  }

  return (
    <MainHeader className={` ${scrollDirection === 'down' ? 'hide' : 'show'}`}>
      {sizeModelShow == 'Desktop' && (
        <HeaderOptionOne
          setShowModal={setShowModal}
          isloggedin={isloggedin}
          userData={userData}
          handleLogout={handleLogout}
          pageText={pageText}
        />
      )}
      {sizeModelShow == 'Tablet/Mobile' && (
        <HeaderOptionTwo
          setShowModal={setShowModal}
          isloggedin={isloggedin}
          userData={userData}
          handleLogout={handleLogout}
          pageText={pageText}
        />
      )}

      <Modal
        showModal={showModal}
        handleClose={() => setShowModal(false)}
        languages={languages}
      ></Modal>
    </MainHeader>
  )
}

export default withAuth(NewHeaderOnboarding)
